import { Roles } from '@/models/admins.model';

export enum AdminsFiltersFields {
  EMAIL = 'email',
  ROLE = 'roles',
  FULL_NAME = 'full_name',
  NAME = 'name',
  ACTIVE = 'active',
  DATE_FROM = 'date_from',
  DATE_TO = 'date_to',
  REGION = 'region',
  PAGE = 'page',
  SIZE = 'size',
}

export enum UsersFiltersFields {
  NAME = 'full_name',
  PHONE = 'phone',
  ACTIVE = 'active',
  CREATED_AT = 'created_at',
  PAGE = 'page',
}

export enum AdminFormFieldsNames {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  ID = 'id',
  ROLE = 'role',
  REGION_ID = 'regionId',
}

export type TAdminFormValues = {
  [AdminFormFieldsNames.FIRST_NAME]: string;
  [AdminFormFieldsNames.ID]: string;
  [AdminFormFieldsNames.LAST_NAME]: string;
  [AdminFormFieldsNames.EMAIL]: string;
  [AdminFormFieldsNames.ROLE]: string;
  [AdminFormFieldsNames.REGION_ID]?: string | null;
};

export type TGetAdminsQuery = {
  [AdminsFiltersFields.EMAIL]?: string;
  [AdminsFiltersFields.ROLE]?: Roles;
  [AdminsFiltersFields.NAME]?: string;
  [AdminsFiltersFields.ACTIVE]?: boolean;
  [AdminsFiltersFields.FULL_NAME]?: string;
  [AdminsFiltersFields.DATE_FROM]?: string;
  [AdminsFiltersFields.DATE_TO]?: string;
  [AdminsFiltersFields.REGION]?: string;
  [AdminsFiltersFields.PAGE]?: number;
  [AdminsFiltersFields.SIZE]?: number;
};

export type TGetUsersQuery = {
  [UsersFiltersFields.NAME]?: string;
  [UsersFiltersFields.PHONE]?: string;
  [UsersFiltersFields.ACTIVE]?: string;
  [UsersFiltersFields.CREATED_AT]?: string;
  [UsersFiltersFields.PAGE]?: number;
};
